import CellValuer from '@/apps/MainApp/views/Dashboard/TableCells/CellValuer.vue'
import { computed, h } from 'vue'
import { useCurUser } from '@/composables/useCurUser'

export const registerValuerColumn = (dashboard) => {
  const { hasRole } = useCurUser()

  dashboard.registerCustomColumn({
    name: 'valuer',
    label: 'monolith.shared.valuer',
    component: (props) => {
      // No need to validate that there's a valuer, as the Cell also allows to set it for dispatchers
      return h(CellValuer, { ...props })
    },
    options: {
      searchable: true,
      filter: 'valuer__info',
      visible: computed(() => {
        return hasRole('dispatcher')
      }),
    },
  })
}
